<script lang="ts">
    import Button from "./Button.svelte";
    import { locale } from '$lib/translations';
    export let buttons: Button[];
</script>


{#each buttons as button}
    {#if button.url || button.page?.data?.attributes?.slug}
        <Button url={button.url ?? `/${$locale}/${button.page.data.attributes.slug}` } title={button.title} type={button.type} color={button.hasDarkBackground ? 'light' : 'dark'}/>
    {/if}
{/each}

